import { render, staticRenderFns } from "./DialogUpsellDetails.vue?vue&type=template&id=5ab68b0a&scoped=true"
import script from "./DialogUpsellDetails.vue?vue&type=script&lang=js"
export * from "./DialogUpsellDetails.vue?vue&type=script&lang=js"
import style0 from "./DialogUpsellDetails.vue?vue&type=style&index=0&id=5ab68b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab68b0a",
  null
  
)

export default component.exports